import { NgModule } from "@angular/core";
import { AppDataService } from "@app/services/appData.service";
import { FeaturesService } from "@app/services/Features.service";
import { HeaderService } from "@app/components/header/header.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";
import { LogoutService } from "@app/services/Logout.service";
import { SpinnerService } from "@app/services/spinner.service";
import { AppInitService } from "@app/services/AppInit.service";
import { UtilService } from "@app/services/Util.service";
import { OauthService } from "@app/services/oauth.service";
import { ScrollService } from "@app/services/Scroll.service";
import { LoginService } from "@app/services/Login.service";
import { MobileLoginService } from "@app/services/MobileLogin.service";
import { VersionCheckService } from "@app/services/VersionCheck.service";
import { PropertiesService } from "@app/services/properties.service";
import { AmenityApi } from "@app/services/apiServices/AmenityApi";
import { WalletService } from "@app/services/wallet.service";
import { CountryAndStateApi } from "@app/services/apiServices/CountryAndStateApi";
import { PaymentHistoryCancelService } from "@app/services/PaymentHistoryCancel.service";
import {
    ExpandedPaymentHistoryDetailComponent
} from "@app/components/expandedPaymentHistoryDetail/expandedPaymentHistoryDetail.component";
import { PaymentScheduleSelectorComponent } from "@app/components/paymentSchedule/paymentScheduleSelector.component";
import { PmcDataService } from "@app/services/pmc-data.service";
import { TabTrapService } from "@app/services/TabTrap.service";
import { PrintService } from "@app/services/Print.service";
import { PaymentDateService } from "@app/services/PaymentDate.service";
import { AmenityService } from "@app/services/Amenity.service";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { UserTimingService } from "@app/services/UserTiming.service";
import { KeyboardService } from "@app/services/Keyboard.service";
import { PushPopService } from "@app/services/push.pop.service";
import { CouponCaptureService } from "@app/services/coupon-capture.service";
import { AppRunService } from "@app/services/AppRunService";
import { CommonService } from "@app/services/CommonService";
import { BnNgIdleService } from "bn-ng-idle";

@NgModule({
    providers: [
        AppDataService,
        FeaturesService,
        HeaderService,
        NetworkErrorService,
        ErrorHandlerService,
        LogoutService,
        SpinnerService,
        AppInitService,
        UtilService,
        OauthService,
        ScrollService,
        LoginService,
        MobileLoginService,
        VersionCheckService,
        PropertiesService,
        AmenityApi,
        WalletService,
        CountryAndStateApi,
        PaymentHistoryCancelService,
        ExpandedPaymentHistoryDetailComponent,
        PaymentScheduleSelectorComponent,
        PmcDataService,
        TabTrapService,
        PrintService,
        PaymentDateService,
        AmenityService,
        HOAApiBase,
        UserTimingService,
        KeyboardService,
        PushPopService,
        CouponCaptureService,
        AppRunService,
        CommonService,
        BnNgIdleService,
    ]
})
export class ServicesModule{}
